import React, {useEffect, useState} from "react";
import {xcService} from "../../../_services/xcService";
import {useTranslation, withTranslation} from "react-i18next";
import {DownloadOutlined, EditOutlined} from "@ant-design/icons";
import {Button, Checkbox, Form, Input, List, Modal, Popconfirm} from 'antd';
import variables from "../../../_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import {RightOutlined, DownOutlined, LogoutOutlined, LockOutlined, FilePdfOutlined} from "@ant-design/icons";
import { pdf } from "@react-pdf/renderer";
import {dataActions} from "../../../_actions";

import "./account.scss";
import {Collapse, Alert, Space, message, notification} from 'antd';
import {PasswordInput} from 'antd-password-input-strength'
import {authActions, tutorAuthActions} from "../../../_actions";
import {useDispatch, useSelector} from "react-redux";
import Accountuser from "./accountuser";
import AccountCenter from "./accountcenter";
import moment from "moment";
import config from "../../../_config/config";
import { MyDocPDFCenterTemplate } from "views/centers/components/pdfcontracttemplate";

const {Panel} = Collapse;

const AccountUserView = () => {
    const {t, i18n} = useTranslation();
    const [passwordChange, setPassowrdChange] = useState(0)
    const [passwordChangeOrion, setPassowrdOrionChange] = useState(0)
    const coursesData = useSelector((state) => state.dataReducer.coursesData);

    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };

     useEffect(()=>{
        getCourses();
    },[])

    
    const [isEditing, setIsEditing] = useState(false)
    const [form] = Form.useForm();
    const [formedit] = Form.useForm();
    const [level, setLevel] = useState(0)
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const userType = storage.getItem(variables.USER_TYPE);
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [message, setMessage] = useState("");
    const [userProfile, setUserProfile] = useState();
    const [show, setShow] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
        logout();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const logout = () => {
        dispatch(userType === 'STUDENT' ? authActions.logout() : tutorAuthActions.logout());
    }

    const localDownloadPDF = async (pdfName, propsPdf) => {
        const blob = await pdf(<MyDocPDFCenterTemplate props= {propsPdf} />).toBlob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = pdfName || 'document.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const minLevel = 0;

    const errorMessage = t("cuenta.debil");

    useEffect(() => {


        xcService.getToken(userType === 'STUDENT' ? '/v1/me' : userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me').then(({data}) => {
            setUserProfile(data.data )
        });

        const {setFieldsValue, getFieldValue} = formedit;

        setFieldsValue({name: user.name, surname: user.surname});
    }, []);

    const onFinishPassword = (values) => {
        let payload = {
            reppassword: values.reppassword,
            password: values.password,
        };

        setPassowrdChange(0)
        xcService.putToken(`/v1/${userType === 'STUDENT' ? 'student' :  userType === 'CENTER' ? 'center' : 'tutor'}/profile/password`, payload)
            .then(({data}) => {

                if (data.code === 4004) {
                    form.resetFields()
                    setPassowrdChange(1);
                }
            }).catch(err => {
            console.error(err);
            setPassowrdChange(2);
        })

    };

    const deleteContract = () => {
        xcService.deleteToken(`/v1/center/contract`)
        .then(({data}) => {

            logout()
        }).catch(err => {
       
    })
    }

    const onFinishPasswordOrion = (values) => {
        let payload = {
            reppassword: values.reppassword,
            password: values.password,
        };

        setPassowrdOrionChange(0)
        xcService.putToken(`/v1/center/profile/passwordorion`, payload)
            .then(({data}) => {

                if (data.code === 4004) {
                    form.resetFields()
                    setPassowrdOrionChange(1);
                }
            }).catch(err => {
            console.error(err);
            setPassowrdOrionChange(2);
        })

    };

    const onFinishFailedPassword = (errorInfo) => {
        console.error('Failed:', errorInfo);
    };


    const downloadPdf =async  (pdf,code, year) => {
        let fullUrl = `${config.backendUrl}/v2/${userType === "MASTER" ? "m" : "c"}contract/${pdf}?code=${code}`;
        const result = await fetch(fullUrl, {
            headers: {
                Authorization: "bearer " + storage.getItem(variables.TOKEN),
                "Content-Type": "application/json"
            },
        });

        if (result?.status === 404) {
            const _result = await result.json()

            const data = _result.data;
            const { values: vstr, values2: v2str} = data || {}

            const values = JSON.parse(vstr)
            const values2 = JSON.parse(v2str)

            const propsPdf = {
              year: year,
              ccaa: userProfile.ccaa,
              user: {email: userProfile.email},
              center: {
                Nombre: userProfile.name,
                Codigo: values.code || userProfile.code,
                Domicilio: userProfile.address,
                CodPostal: userProfile.postalcode,
                Telefono: userProfile.phone,
              },
              courses: coursesData || [],
              values: {
                ...values,
                orientadores: values2.orientadores || userProfile.orientadores || [],
                directorName: values2.directorName || userProfile.directorName,
                directorDni: values2.directorDni || userProfile.directorNif,
                directorSurname: values2.directorSurname || userProfile.directorSurname,
                jefeEmail: values2.jefeEmail || userProfile.jefeestmail,
                directorEmail: values2.directorEmail || userProfile.directorEmail,
                jefeName: values2.jefeName || userProfile.jefeest,
                jefeSurname: values2.jefeSurname || "",
                orientadornombre: values2.orientadornombre || "",
                orientadorapellidos: values2.orientadorapellidos || "",
                orientadortelef: values2.orientadortelef || "",
                orientadoremail: values2.orientadoremail || "",
                orientadordni: values2.orientadordni || "",
              },
            };

            await localDownloadPDF( pdf, propsPdf);
            await uploadPDF(pdf, propsPdf);

            showNotification(); /* TODO: por comentar posiblemente no se usara*/
            return;
        }

        const blob = await result.blob();
        const href = window.URL.createObjectURL(blob);
        window.open(href, '_blank');

    }

    const showNotification = () => {
        notification.success({
            message: 'Contrato en descarga',
            description: 'El contrato ha sido generado con los datos más recientes.',
            duration: 4,
            style: { backgroundColor: '#fdecea', border: '1px solid #f5c6cb', color: '#721c24' },
        });
    };

    const uploadPDF = async (pdfId, propsPdf) => {
        const _pdfId = pdfId.replace('.pdf', '')
        const blob = await pdf(<MyDocPDFCenterTemplate props= {propsPdf} />).toBlob();
        const formData = new FormData();
        formData.append("file", new File([blob], pdfId || "document.pdf", { type: "application/pdf" }));
        
        try {
            const response = await fetch(`${config.backendUrl}/v1/uploadcontract/${_pdfId}`, {
            method: "POST",
            body: formData,
            })
            ;
            if (!response.ok) throw new Error("Error al subir el archivo");
        //   const fileName = await response.text();
        } catch (error) {
            console.error("Error al subir el PDF:", error);
        }
    };


    const onClose = (e) => {
        setShow(false);
        setMessage("")
    };

    const copyLink = (passcode) => {
        navigator.clipboard.writeText(passcode)
        setShow(true);
        setMessage(t("account.claveorion") + " " + t("iscopy"));
    }

    return (
        <>

            <Modal className={"modalName modal-question modal-question--xs modal-custom--xs"} title={t("cerrarsesiont")}

                   okText={t("cerrarsesions")}
                   cancelText={t("cancel")}

                   open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <p>{t("cerrarsesiona")}</p>
            </Modal>


            <div className={"container container--default container--account boxed boxed--layout"}>
                <div className="default-header">
                    <div className="default-header__top">
                        <h1>{t("account.title")}</h1>
                    </div>
                    {userType === 'CENTER' &&
                        <p>{t("account.descenter")}</p>
                    }
                </div>
                <div className="default-content">
                    <div className={"content-left"}>
                        <ul className={"left-menu"}>
                              <li className={"left-menu-item is-active"}>{
                                userType === 'STUDENT' ? t("account.subtitlestuden") :
                                    userType === 'CENTER' ? t("account.subtitlecenter") :
                                        userType === 'TUTOR' ? t("account.subtitletutor") : t("account.subtitlecounselor")}
                                <RightOutlined/></li>

                            <li className={"left-menu-item"} onClick={showModal}>Salir <LogoutOutlined/></li>
                        </ul>
                    </div>
                    <div className={"content-right"}>
                        <h2>{userType === 'STUDENT' ? t("account.subtitlestuden") :
                            userType === 'CENTER' ? t("account.subtitlecenter") :
                                userType === 'TUTOR' ? t("account.subtitletutor") : t("account.subtitlecounselor")}</h2>
                        {userProfile &&
                            <>
                                {userType === 'CENTER' ?
                                    <AccountCenter user={user} t={t} userProfile={userProfile}/>
                                    :
                                    <Accountuser user={user} t={t} userProfile={userProfile}/>}
                            </>
                        }
                        {/* INICIO FORMULARIO CAMBIAR DATOS */}
                        {userProfile && (userType === "CENTER" || userType === "COUNSELOR") &&
                            <div className={"boxPasscode"}>
                                <strong>{t("account.claveorion")}</strong> {userType === "CENTER" ? userProfile.passcode : userProfile.center.passcode}
                                {userProfile &&<Button onClick={() => copyLink(userType === "CENTER" ? userProfile.passcode : userProfile.center.passcode)}  className="btnWhiteBlue modal-question--button" htmlType="button">{t("tutores.informes.copy")}</Button>}
                                {show &&
                                    <Alert
                                        message={message}
                                        type="success"
                                        closable
                                        onClose={onClose}
                                    />}
                            </div>

                        }

                        <Collapse accordion>
                            {userType === "CENTER" &&
                                <Panel header={t("account.claveorion")} key="6">
                                    <div>

                                        {passwordChangeOrion === 1 &&
                                            <Alert closable
                                                   onClose={() => setPassowrdOrionChange(0)} message={t("login.passwordc")}
                                                   type="success"/>
                                        }
                                        {passwordChangeOrion === 2 &&
                                            <Alert closable
                                                   onClose={() => setPassowrdOrionChange(0)} message="Success Text"
                                                   type="error"/>
                                        }
                                        <Alert message={t("account.aviso")} type="warning" />
                                        <Form
                                            form={form}
                                            name="basic"
                                            initialValues={{remember: true}}
                                            onFinish={onFinishPasswordOrion}
                                            onFinishFailed={onFinishFailedPassword}
                                            autoComplete="off"
                                        >
                                            <div className={"display-flex"}>
                                                <Form.Item
                                                    label={t("account.newpassword")}
                                                    name="password"
                                                    rules={[
                                                        {required: true, message: t("login.passwordMandatory")},
                                                        {
                                                            validator: async () => {
                                                                return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                                                            },
                                                            message: errorMessage
                                                        }

                                                    ]}
                                                >
                                                    <PasswordInput
                                                        onLevelChange={setLevel}
                                                        settings={{
                                                            height: 7, alwaysVisible: true, colorScheme: {
                                                                levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                                                                noLevel: "lightgrey"
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label={t("account.repitenewpassword")}
                                                    name="reppassword"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t("login.passwordMandatory"),
                                                        },
                                                        ({getFieldValue}) => ({
                                                            validator(_, value) {
                                                                if (!value || getFieldValue('password') === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error(t("login.passwordmis")));
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input.Password/>
                                                </Form.Item>
                                            </div>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit">
                                                    {t("account.save")}
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </Panel>
                            }
                            <Panel header={t("login.password")} key="1">
                                <div>
                                    {passwordChange === 1 &&
                                        <Alert closable
                                               onClose={() => setPassowrdChange(0)} message={t("login.passwordc")}
                                               type="success"/>
                                    }
                                    {passwordChange === 2 &&
                                        <Alert closable
                                               onClose={() => setPassowrdChange(0)} message="Success Text"
                                               type="error"/>
                                    }
                                    <Form
                                        form={form}
                                        name="basic"
                                        initialValues={{remember: true}}
                                        onFinish={onFinishPassword}
                                        onFinishFailed={onFinishFailedPassword}
                                        autoComplete="off"
                                    >
                                        <div className={"display-flex"}>
                                            <Form.Item
                                                label={t("account.newpasswordcc")}
                                                name="password"
                                                rules={[
                                                    {required: true, message: t("login.passwordMandatory")},
                                                    {
                                                        validator: async () => {
                                                            return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                                                        },
                                                        message: errorMessage
                                                    }

                                                ]}
                                            >
                                                <PasswordInput
                                                    onLevelChange={setLevel}
                                                    settings={{
                                                        height: 7, alwaysVisible: true, colorScheme: {
                                                            levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                                                            noLevel: "lightgrey"
                                                        }
                                                    }}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                label={t("account.repitenewpasswordcc")}
                                                name="reppassword"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t("login.passwordMandatory"),
                                                    },
                                                    ({getFieldValue}) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error(t("login.passwordmis")));
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password/>
                                            </Form.Item>
                                        </div>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">
                                                {t("account.save")}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Panel>
                            {userProfile && userType  === "CENTER" &&
                                <Panel header={t("account.contratos")} key="2">

                                    <List
                                        itemLayout="horizontal"
                                        dataSource={userProfile.centerhistories}
                                        renderItem={(item) => (
                                            <List.Item
                                                actions={[<a onClick={() => downloadPdf(item.pdf, userProfile.code, item.year)}  target={"_blank"} >
                                                    <DownloadOutlined />
                                                </a>]}
                                            >
                                                <List.Item.Meta
                                                    avatar={<FilePdfOutlined />}
                                                    title={t("account.adhesion") + " " +  item.year + "/" + (+item.year+1)}
                                                    description={t("account.fechaEnvio") + " " + moment(item.createdAt).format("DD/MM/yyyy")}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                      <Popconfirm onConfirm={() => deleteContract()}
                                        title={t("sirenova")}
                                        okText={t("yes")}
                                        cancelText="No"><a href={"#"}>
                                                {t("renovarc")} <RightOutlined/>
                                            </a></Popconfirm>
                                </Panel>
                            }
                        </Collapse>
                        {/* FIN FORMULARIO CAMBIAR PASSWORD */}
                    </div>
                </div>
            </div>
        </>)


}


export default withTranslation()(AccountUserView);
